module.exports = __webpack_public_path__ + "static/media/3dcards-JS.ba0f9aa1.PNG";